import { useRootContext } from 'context/root';

import { Redirect } from './Redirect';

export const AuthRedirect = ({ to, auth }: { to: string; auth: string }) => {
  const { user } = useRootContext();
  return <Redirect to={user?.id ? to : auth} />;
};
